import { render, staticRenderFns } from "./ServerBanner.vue?vue&type=template&id=559ac0eb&scoped=true"
import script from "./ServerBanner.vue?vue&type=script&lang=js"
export * from "./ServerBanner.vue?vue&type=script&lang=js"
import style0 from "./ServerBanner.vue?vue&type=style&index=0&id=559ac0eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559ac0eb",
  null
  
)

export default component.exports